export const INPUT_COLUMNS_RESPONSIVE_CSS = `
@container au-settings-panel (max-width: 630px) {
  .au-settings-panel .au-input-same-line {
    display: block;
    width: 100%;
  }

  .au-settings-panel .au-input-before-same-line {
    padding-right: 0;
  }

  .au-settings-panel .au-input-same-line:not(:last-child),
  .au-settings-panel .au-input-before-same-line:not(:last-child) {
    margin-bottom: 18px;
  }

  .au-settings-panel .au-limit-sort {
    flex-wrap: wrap;
  }

  .au-settings-panel .au-limit-sort .au-limit-sort-limit {
    width: 100%;
    margin-right: 0;
    margin-bottom: 18px;
  }

  .au-settings-panel .au-limit-sort .au-limit-sort-by {
    flex: 1 1 0;
    width: auto;
  }

  .au-settings-panel .au-limit-sort .au-limit-sort-direction {
    flex: 0 0 auto;
    width: auto;
  }
}
`;

const STYLE_ELEMENT_ID = "au-input-columns-responsive";

export const injectInputColumnsResponsiveStyles = (): void => {
  if (typeof document === "undefined") {
    return;
  }
  if (document.getElementById(STYLE_ELEMENT_ID) !== null) {
    return;
  }
  const style = document.createElement("style");
  style.id = STYLE_ELEMENT_ID;
  style.textContent = INPUT_COLUMNS_RESPONSIVE_CSS;
  document.head.appendChild(style);
};
